import { Deal } from '../../models/shared/Deal'
import { Dropdown } from 'react-bootstrap'
import { ThreeDotsToggle } from '../ThreeDotsToggle'
import { useText } from '../../context/TextContext'
import { isMobileDevice, navigateOnMap } from '../../utils/logic'
import { AdvancedDropdownItem } from '../AdvancedDropdownItem'
import { Offer } from '../../models/shared/Offer'
import { useEnsureOffer } from '../../hooks/useEnsureOffer'
import { useOrganization } from '../../context/OrganizationContext'
import { UserRole } from '../../models/shared/UserInvitation'

interface Props {
    deal: Deal
    offers?: Offer[];
    onNewDueDate: () => void
    onNewAttachment: (capture: boolean) => void
    onDealArchive: (deal: Deal) => void
}

export default function DealModalActions(props: Props) {
    const text = useText();
    const { deal } = props
    const handleOfferClick = useEnsureOffer();
    const { orgRole } = useOrganization();
    const isWorker = orgRole === UserRole.WORKER;

    const hasOffers = props.offers && props.offers.length > 0;

    return (
        <Dropdown drop='start'>
            <Dropdown.Toggle as={ThreeDotsToggle} size='sm' />
            <Dropdown.Menu >
                {!isWorker &&
                    <AdvancedDropdownItem
                        icon='bi-receipt'
                        onClick={() => handleOfferClick(deal, props.offers || [])}
                        text={hasOffers ? text.manageOffers : text.newOffer}
                    />
                }

                {isMobileDevice() &&
                    <AdvancedDropdownItem
                        icon='bi-camera'
                        onClick={() => props.onNewAttachment(true)}
                        text={text.takePhoto}
                    />
                }
                {!deal.dueAt &&
                    <AdvancedDropdownItem
                        icon='bi-calendar'
                        onClick={props.onNewDueDate}
                        text={text.addDueDate}
                    />
                }
                <AdvancedDropdownItem
                    icon='bi-paperclip'
                    onClick={() => props.onNewAttachment(false)}
                    text={text.addAttachment}
                />
                {deal.place?.geocoding &&
                    <AdvancedDropdownItem
                        icon='bi-sign-turn-right'
                        onClick={() => navigateOnMap(deal.place?.geocoding)}
                        text={text.navigate}
                    />
                }

                <Dropdown.Divider />
                <AdvancedDropdownItem
                    icon='bi-trash'
                    onClick={() => props.onDealArchive(deal)}
                    text={text.archive}
                />
            </Dropdown.Menu>
        </Dropdown>
    )
}
